import React from "react";
import { Link } from "react-router-dom";
import { FaChevronDown, FaSignOutAlt, FaTachometerAlt, FaUserCircle } from "react-icons/fa";
import { isAdmin } from "../utils/roleUtils";

export default function PublicAccountMenu({ user, logout, onNavigate }) {
  if (!user) return null;

  const displayName = user.full_name || user.name || user.email || "Account";
  const dashboardPath = isAdmin(user) ? "/admin/dashboard" : "/dashboard";

  return (
    <details className="adv-home-account-menu">
      <summary className="adv-home-account-trigger">
        <FaUserCircle aria-hidden="true" />
        <span>Hi, {displayName}</span>
        <FaChevronDown className="adv-home-account-chevron" aria-hidden="true" />
      </summary>
      <div className="adv-home-account-dropdown">
        <Link to={dashboardPath} className="adv-home-account-item" onClick={onNavigate}>
          <FaTachometerAlt aria-hidden="true" />
          <span>Dashboard</span>
        </Link>
        <button type="button" className="adv-home-account-item" onClick={logout}>
          <FaSignOutAlt aria-hidden="true" />
          <span>Logout</span>
        </button>
      </div>
    </details>
  );
}
